module.exports = __webpack_public_path__ + "static/index/files/account-deletion-manual.pdf";